<template>
  <footer class="p-4 md:px-6 md:py-4 dark:bg-gray-800">
    <div
        class="
        sm:flex sm:items-center sm:justify-around
        dark:bg-gray-200
        text-3xl
      "
    >
      Powered by:
      <a
          href="http://www.oegemadesailab.org/oegema-research"
          class="flex"
          target="_blank"
      >
        <img
            src="@/assets/ODlab_logo.png"
            width="140px"
            alt="ODlab Logo"
        >
      </a>
      <a
          href="https://hymanlab.org/hyman_lab/"
          class="flex"
          target="_blank"
      >
        <img
            src="@/assets/hyman-logo.gif"
            width="200px"
            alt="HymanLab Logo"
        >
      </a>
      <a
          href="https://mpi-cbg.de"
          class="flex"
          target="_blank"
      >
        <img
            src="@/assets/MPI_CBG_Logo_horizontal_black.png"
            width="300px"
            alt="MPI-CBG Logo"
        >
      </a>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8">
    <!-- <span
        class="block text-2xl text-white-base sm:text-center dark:text-gray-400"
        >© 2022 <a href="/" class="hover:underline">CD-CODE</a>. All Rights
        Reserved.
      </span> -->
    <div class="sm:flex sm:items-center sm:justify-between">
      <!-- <span class="text-2xl text-white-base sm:text-center dark:text-gray-400">

       </span> -->
      <div class="mr-4 md:mr-6">
        <a
            class="hover:underline hover:text-pink-base"
            href="https://www.mpi-cbg.de/impressum"
        >Impressum</a>
        &nbsp; | &nbsp;
        <a
            class="hover:underline hover:text-pink-base"
            href="https://www.mpi-cbg.de/privacy-policy"
        >Privacy Policy</a>
          &nbsp; | &nbsp; Content Management by <a
          class="hover:underline hover:text-pink-base"
          href="/"
          >Rebecca A. Green</a>
      </div>

      <span
          class="text-2xl text-black-base sm:text-center dark:text-gray-400"
      >© 2022
        <a
            href="/"
            class="hover:underline hover:text-pink-base"
        >Phenobank</a>.
        All Rights Reserved.
      </span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  mounted: function () {

  },
};
</script>
